import React, {Component, Fragment} from 'react';
// import CsodTableRow from "./CsodTableRow";
// import CsodTableHeader from "./CsodTableHeader";

//import {connect} from "react-redux";

class CsodFormWraper extends Component {

    render() {
        // const {data} = this.props;

        return (
            <Fragment>
                <div className="cso-grey-panel cso-corner cso-cont-pad10t cso-cont-marb10">
                    <table className="sc-layout-tbl">
                        <tbody>
                        {this.props.children}
                        </tbody>
                    </table>
                </div>
                <div className="cso-txtr cso-cont-pad10tb sc-btn-grp">
                    <a data-tag="cmdBack"
                       className="cso-btn cso-action cso-corner cso-btn-grey"
                       onMouseUp="blur();"
                       onClick={() => this.props.onClose()}
                       role="button"><span><b>Cancel</b></span></a>
                    <a data-tag="cmdSave"
                       className="cso-btn cso-action cso-corner cso-btn-primary"
                       role="button"
                    ><span><b>Save</b></span></a>
                </div>
            </Fragment>


        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         version: state.layout.version,
//     };
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         setVersion: () => dispatch(setVersion()),
//     };
// };

//Widget = connect(mapStateToProps, mapDispatchToProps)(FrontLayout)

export default CsodFormWraper;


// WEBPACK FOOTER //
// ./src/widgets/components/Csod/CsodFormWraper.js